import { useState, useEffect, useCallback } from "react";
import { userService } from "../services/user.service";
const { getUsers } = userService;

const useCedentes = () => {
  const [cedentes, setCedentes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCedentes = useCallback(async () => {
    try {
      setIsLoading(true);
      const data = await getUsers();
      setCedentes(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCedentes();
  }, [fetchCedentes]);

  return { cedentes, setCedentes, isLoading, error, refresh: fetchCedentes };
};

export default useCedentes;
